import { takeEvery, fork, delay, put, all, call } from "redux-saga/effects"
import { deleteNotificationAPI, getNotificationAPI, sendEmpMailAPI, sendNotificationAPI } from "./api"
import { getNotificationSuccess, getNotificationFailure, sendNotificationSuccess, sendNotificationFail, deleteNotificationSuccess, deleteNotificationFailed, sendEmpMailSuccess, sendEmpMailFailed } from "./action"
import { DELETE_NOTIFICATION, GET_NOTIFICATION_START, SEND_EMP_MAIL, SEND_NOTIFICATION_START } from "./constant"

function* getNotificationAsync() {
  try {
    const response = yield call(getNotificationAPI)

    // console.log(typeof(response.data.notificationCount.birthdays))
    // console.log(typeof(response.data.notificationCount.others))

    if (response.status === 200) {
      delay(400)
      let N =
        response.data.notificationCount.birthdays +
        response.data.notificationCount.others

      localStorage.setItem("notificationCount", N)

      yield put(getNotificationSuccess(response.data))
    } else {
      yield put(getNotificationFailure(response.data))
    }
  } catch (error) {
    yield put(getNotificationFailure(error.response.data))
  }
}

function* getNotificationfunc() {
  yield takeEvery(GET_NOTIFICATION_START, getNotificationAsync)
}

function* sendNotificationAsync(action) {
  try {
    const response = yield call(sendNotificationAPI, action.payload)

    if (response.status === 200) {
      delay(400)

      yield put(sendNotificationSuccess(response.data))
    } else {
      yield put(sendNotificationFail(response.data))
    }
  } catch (error) {
    yield put(sendNotificationFail(error.response.data))
  }
}

function* sendNotificationfunc() {
  yield takeEvery(SEND_NOTIFICATION_START, sendNotificationAsync)
}




function* deleteNotificationAsync(action) {
  try {
    const response = yield call(deleteNotificationAPI, action.payload)
    if (response.status === 200) {
      delay(400)

      yield put(deleteNotificationSuccess({notiId: action.payload.notiId, message: 'Notification Deleted Successfully'}))
    } else {
      yield put(deleteNotificationFailed(error.response.data || "Something went wrong, please try again"))
    }
  } catch (error) {
    yield put(deleteNotificationFailed(error.response.data || "Something went wrong, please try again"))
  }
}

function* deleteNotificationfunc() {
  yield takeEvery(DELETE_NOTIFICATION, deleteNotificationAsync)
}




function* sendEmpMailAsync(action) {
  try {
    const response = yield call(sendEmpMailAPI, action.payload)

    if (response.status === 200) {
      delay(400)

      yield put(sendEmpMailSuccess(response.data))
    } else {
      yield put(sendEmpMailFailed(response.data))
    }
  } catch (error) {
    yield put(sendEmpMailFailed(error.response.data))
  }
}

function* sendEmpMailFunc() {
  yield takeEvery(SEND_EMP_MAIL, sendEmpMailAsync)
}



function* Notification() {
  yield all(
    [
      fork(getNotificationfunc),
      fork(sendNotificationfunc),
      fork(deleteNotificationfunc),
      fork(sendEmpMailFunc),
    ]
   
  )
}
export default Notification
